// TB-161: one place for how a straight-line doctor distance is shown.
export const DISTANCE_TITLE = 'Straight-line distance, not the driving route'
export const CENTRE_TITLE = 'Add your address in your profile to see the distance from you'

/** "200 m" under 1 km, "4.3 km" from 1 km. Empty text when the value is not a distance. */
export function formatDistance (km) {
  const n = Number(km)
  if (km === null || km === undefined || km === '' || !Number.isFinite(n) || n < 0) return ''
  if (n < 1) return `${Math.round(n * 1000)} m`
  return `${n.toFixed(1)} km`
}
